import { gql } from '@apollo/client';

export const ON_FINANCIAL_TILES_UPDATED = gql`
  subscription FinancialTilesUpdated {
    financialTilesUpdated {
      firmId
    }
  }
`;
